import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css"; // Custom CSS for additional styling
// Components
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import GauSeva from "./pages/GauSeva";
import VideoPage from "./pages/Video";
// import BlogGridPage from "./pages/BlogGridPage";
// import BlogDetailPage from "./pages/BlogDetailPage";
import BlogPage from "./pages/BlogPage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SingleBlog from "./pages/SingleBlog";
import KathaExperience from "./pages/KathaExperience";
import { KathaTranslationProvider } from "./components/KathaAutoTranslation";
// Pages

// Scroll to top logic - Naye page par jaane par screen top par laane ke liye
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <KathaTranslationProvider>
      <Router>
        <ToastContainer />
        <div
          style={{
            backgroundColor: "#fffaf5",
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <ScrollToTop />
          <Header />

          {/* Main Content Area */}
          <div style={{ flex: 1 }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/video" element={<VideoPage />} />
              {/* <Route path="/blog" element={<BlogGridPage />} /> */}
              <Route path="/blogs" element={<BlogPage />} />
              {/* <Route path="/blog/:id" element={<BlogDetailPage />} /> */}
              <Route path="/blogs/:id" element={<SingleBlog />} />
              <Route path="/gau-seva" element={<GauSeva />} />
              <Route path="/katha" element={<KathaExperience />} />
              <Route
                path="/katha/page/:pageNum"
                element={<KathaExperience />}
              />
              <Route path="/katha/:bookSlug" element={<KathaExperience />} />
              <Route
                path="/katha/:bookSlug/page/:pageNum"
                element={<KathaExperience />}
              />
              <Route
                path="/katha/:bookSlug/:storySlug"
                element={<KathaExperience />}
              />
              {/* 404 Page (Optional) */}
              <Route
                path="*"
                element={
                  <div className="py-5 text-center">
                    <h1>404 - Page Not Found</h1>
                  </div>
                }
              />
            </Routes>
          </div>

          <Footer />
        </div>
      </Router>
    </KathaTranslationProvider>
  );
}

export default App;
